import { fetcher } from "@repo/api";
import { useSettings } from "@repo/ui";
import useSWR, { mutate } from "swr";

import { type Tags } from "./types";

export function useTags() {
  const { market } = useSettings();
  return useSWR<Tags[]>(
    `/tags?countryCode=${market}&countryCode=GLOBAL`,
    (url: string) => fetcher.opportunity.get<Tags[]>(url)
  );
}

export const saveTags = async (
  selectedTags: string[],
  opportunityId: number
) => {
  if (selectedTags) {
    const res = await fetcher.opportunity.post<Tags[], false>(
      `/${opportunityId}/tags`,
      {
        tags: selectedTags,
      }
    );

    mutate(`/opportunities/${opportunityId}`);
    mutate(`/opportunities/${opportunityId}/history`);
    return res;
  }
};
